import { put, takeLatest, select, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';

import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';
import {
    analyticsNorthStarEndpoint,
    analyticsNorthStarV2Endpoint
} from './selectors';

import {
    actions,
    fetchAnalyticsSuccess,
    fetchAnalyticsV2Success
} from './duck';

export function* fetchAnalyticsV2(api, action) {
    const notificationId = action.type;
    try {
        const state = action.getState();
        const result = yield apiAuthCall(
            state,
            [api, api.request],
            {
                method: 'get',
                url: yield select(analyticsNorthStarV2Endpoint)
            }
        );
        yield put(fetchAnalyticsV2Success(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}
export function* fetchAnalytics(api, action) {
    const notificationId = action.type;

    try {
        const state = action.getState();
        const result = yield apiAuthCall(
            state,
            [api, api.request],
            {
                method: 'get',
                url: yield select(analyticsNorthStarEndpoint)
            }
        );
        yield put(fetchAnalyticsSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export default function* analyticsSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH_ANALYTICS, fetchAnalytics, api),
        takeLatest(actions.FETCH_ANALYTICS_V2, fetchAnalyticsV2, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/analytics/saga.js